import Airtable from "airtable";

Airtable.configure({
  apiKey:
    "patEOaB8TcTYLboff.023631b214de178b27a54e8f6440867396ed95a107b731ea1ef1906d185b09ad",
});

const base = Airtable.base("appPHSa0IZLF8Cl3p");

export const getParticipants = async (columnName = "Name") => {
  try {
    const records = await base("tblcZzjQf0377JGpv").select().all();
    console.log("Fetched records:", records);
    const participants = records.map((record) => record.get(columnName));
    console.log("Extracted participants:", participants);
    return participants;
  } catch (error) {
    console.error("Error fetching participants:", error);
    return [];
  }
};
